import { ChevronDownOutlined } from "@JohnLewisPartnership/jl-design-system/dist/components/icons/ChevronDownOutlined";
import { ProductCardLayoutProps } from "../../types/types";
import { Slot } from "../ProductCardSlot";
import styles from "./List.module.scss";
import classNames from "classnames/bind";
import { sendMonetateEvent } from "@~/utils/sendMonetateEvent";

const cx = classNames.bind(styles);

export const slotNameMap = {
  BANNER: "banner",
  IMAGE: "image",
  TOP: "top",
  DETAILS: "details",
  ACTIONS: "actions",
  BENEATH_IMAGE: "beneath-image",
  SECONDARY_ACTIONS: "secondary-actions",
  ASIDE: "aside",
  EXTRA: "extra",
};

export const List = ({ config, product, index }: ProductCardLayoutProps) => {
  return (
    <article
      onClick={() => {
        sendMonetateEvent("productCard.interaction");
      }}
      className={styles["card-container"]}
      data-product-card-layout="List"
      data-testid="product-card-layout"
      data-product-id={product?.aliases?.pimProductId}
      id={product?.aliases?.pimProductId} // Needed for wish list scrolling
    >
      <div className={styles["inner-container"]}>
        <div className={styles["left-column"]}>
          <Slot
            slotName={slotNameMap["BANNER"]}
            className={styles["banner-slot"]}
            config={config}
            product={product}
            index={index}
          />
          <div className={styles["image-container"]}>
            <Slot
              slotName={slotNameMap["IMAGE"]}
              className={styles["image-slot"]}
              config={config}
              product={product}
              index={index}
            />
            <Slot
              slotName={slotNameMap["ACTIONS"]}
              className={styles["actions-slot"]}
              config={config}
              product={product}
              index={index}
            />
          </div>
          <Slot
            slotName={slotNameMap["BENEATH_IMAGE"]}
            className={styles["beneath-image-slot"]}
            config={config}
            product={product}
            index={index}
          />
        </div>

        <div className={styles["top-container"]}>
          <Slot
            slotName={slotNameMap["TOP"]}
            className={styles["top-slot"]}
            config={config}
            product={product}
            index={index}
          />
          <Slot
            slotName={slotNameMap["SECONDARY_ACTIONS"]}
            className={styles["secondary-actions-slot"]}
            config={config}
            product={product}
            index={index}
          />
        </div>

        <Slot
          slotName={slotNameMap["ASIDE"]}
          className={styles["aside-slot"]}
          config={config}
          product={product}
          index={index}
        />

        <div className={styles["details-container"]}>
          <div className={styles["details-accordion"]}>
            <button
              data-testid="details-accordion-button"
              aria-expanded={index === 0 ? "true" : "false"}
              aria-controls={`details-accordion-${product?.aliases?.pimProductId}`}
              type="button"
              className={styles["details-accordion-button"]}
              onClick={(event: React.MouseEvent<HTMLButtonElement>) => {
                const button = event.currentTarget;
                button.setAttribute(
                  "aria-expanded",
                  button.getAttribute("aria-expanded") === "true"
                    ? "false"
                    : "true",
                );
              }}
            >
              Key specifications:
              <ChevronDownOutlined
                className={styles["details-accordion-icon"]}
                size="medium"
              />
            </button>
            <Slot
              slotName={slotNameMap["DETAILS"]}
              id={`details-accordion-${product?.aliases?.pimProductId}`}
              className={cx("details-slot", "details-accordion-panel")}
              config={config}
              product={product}
              index={index}
            />
          </div>
          <Slot
            slotName={slotNameMap["EXTRA"]}
            className={styles["extra-slot"]}
            config={config}
            product={product}
            index={index}
          />
        </div>
      </div>
    </article>
  );
};
